(function () {
    'use strict';

    angular
        .module('ActionManager')
        .factory('action-download', actionFunc);

    function actionFunc($q, lodash) {
        const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.
        return function (options, data, actionResponseData) {
            return $q.when(run());

            function run() {
                if (lodash.has(options, 'route')) {

                    let postData = data;
                    if (lodash.has(options, 'useActionResponse') && options.useActionResponse === true) {
                        postData = actionResponseData;
                    }

                    let endpoint = decodeURI(options.route).replace(urlReplacerRegex, (match, submatch) => {
                        return lodash.get(postData, submatch, '');
                     });

                    if (lodash.get(options, 'new_tab', false) === true) {
                        window.open(endpoint, "_blank");
                    } else {
                        window.location.href = endpoint;
                    }
                }
                return true;
            }
        };
    }
})();
